import { render, staticRenderFns } from "./LocalFilter.vue?vue&type=template&id=1582cee5&scoped=true&"
import script from "./LocalFilter.vue?vue&type=script&lang=js&"
export * from "./LocalFilter.vue?vue&type=script&lang=js&"
import style0 from "./LocalFilter.vue?vue&type=style&index=0&id=1582cee5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1582cee5",
  null
  
)

export default component.exports